export const debugging = false;

export const debugConsole = {
    log: () => {},
    warn: () => {},
    error: () => {},
};

export function getMeta() {
    return false;
}

export async function postJSON() {
    return undefined;
}

export function generateSHA1Hash(value) {
    let hash = 0;

    for (let index = 0; index < value.length; index += 1) {
        hash = (hash << 5) - hash + value.charCodeAt(index);
        hash |= 0;
    }

    return String(hash >>> 0);
}
